// Register screens and boot from authoritative server state.

import "./test-media.js"; // first: in test mode (?test) it swaps camera/mic before the SDK loads
import { api } from "./api.js";
import { go } from "./ui.js";
import "./screens/gate.js";
import "./screens/access.js";
import { resumeQueue } from './queue.js';
import "./screens/in-session.js";
import "./screens/history.js";

/** Decides the first screen. Also called by the gate after a correct code. */
export async function boot() {
  try {
    const { resume, queue, profileRequired } = await api("/api/me");
    if (profileRequired) return go('gate', { completeProfile: true });
    if (queue?.status !== 'active' && resumeQueue(queue)) return;
    if (resume?.kind === "call") return go("permission", { sessionId: resume.sessionId, resumed: true });
    if (resume?.kind === "end") return go("end", { sessionId: resume.sessionId });
    go("role"); // a talker's open session shows there under "Current session"
  } catch (e) {
    if (e.status !== 401) console.error(e);
    go(e.data?.error === 'access_required' ? 'access' : 'gate');
  }
}

boot();
